var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"text-left"},[_c('button',{staticClass:"btn btn-fg btn-add custom-shadow-btn",on:{"click":_vm.handleAdd}},[_c('em',{staticClass:"fa fa-plus"}),_vm._v("\n      "+_vm._s(_vm.$t('common_words.add'))+" "+_vm._s(_vm.getBtnTitle)+"\n    ")])]),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }